// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"I5-z"};